import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
// //Import Scrollbar
import SimpleBar from "simplebar-react";
// MetisMenu
import MetisMenu from "metismenujs";
import { Link, useLocation } from "react-router-dom";
import { PERMISSIONS } from "../../api/permissions";

const SidebarContent = (props) => {
  const { t } = useTranslation();

  const location = useLocation();
  const ref = useRef();
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = location.pathname;

    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, []);

  useEffect(() => {
    ref.current.recalculate();
  });

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }

  useEffect(() => {
    document.body.classList.remove("sidebar-enable");
  }, [location]);
  const permissions = JSON.parse(localStorage.getItem("permissions")) || [];

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {permissions.includes(PERMISSIONS.ADMIN_VIEW) && (
              <li>
                <Link to="/admins">
                  <i className="bx bx-user"></i>
                  <span>{t("pages.Admins")}</span>
                </Link>
              </li>
            )}
            {permissions.includes(PERMISSIONS.ROLE_VIEW) && (
              <li>
                <Link to="/roles">
                  <i className="bx bx-user-circle"></i>
                  <span>{t("pages.Roles")}</span>
                </Link>
              </li>
            )}

            {permissions.includes(PERMISSIONS.EMPLOYEE_VIEW) && (
              <li>
                <Link to="/employees">
                  <i className="bx bx-user-circle"></i>
                  <span>Employees</span>
                </Link>
              </li>
            )}
            {permissions.includes(PERMISSIONS.COMPANY_VIEW) && (
              <li>
                <Link to="/companies">
                  <i className="bx bxs-business"></i>
                  <span>Companies</span>
                </Link>
              </li>
            )}
            {permissions.includes(PERMISSIONS.POULE_VIEW) && (
              <li>
                <Link to="/pools">
                  <i className="bx bx-customize"></i>
                  <span>Pooles</span>
                </Link>
              </li>
            )}

            {permissions.includes(PERMISSIONS.CONTRACTS_VIEW) && (
              <li>
                <Link to="/contracts">
                  <i className="bx bx-receipt"></i>
                  <span>Contracts</span>
                </Link>
              </li>
            )}

            {permissions.includes(PERMISSIONS.PRICE_COMPONENT_VIEW) && (
              <li>
                <Link to="/price-components">
                  <i className="bx bx-credit-card-alt"></i>
                  <span>Price Components</span>
                </Link>
              </li>
            )}

            {permissions.includes(PERMISSIONS.INVOICES_VIEW) && (
              <li>
                <Link to="/invoices">
                  <i className="bx bx-edit-alt"></i>
                  <span>Invoices</span>
                </Link>
              </li>
            )}

            {permissions.includes(PERMISSIONS.INVOICES_VIEW) && (
              <li>
                <Link to="/hour-collections">
                  <i class="bx bxs-stopwatch"></i>
                  <span>Hours Collections</span>
                </Link>
              </li>
            )}

            {permissions.includes(PERMISSIONS.PAYSLIPE_VIEW) && (
              <li>
                <Link to="/payslipes">
                  <i className="bx bx-credit-card"></i>
                  <span>Payslipes</span>
                </Link>
              </li>
            )}

            {permissions.includes(PERMISSIONS.INTERNAL_PAYSLIPE_VIEW) && (
              <li>
                <Link to="/internal-payslipes">
                  <i className="bx bxs-credit-card"></i>
                  <span>Internal Payslipes</span>
                </Link>
              </li>
            )}

            {permissions.includes(PERMISSIONS.DEDUCTIONS_VIEW) && (
              <li>
                <Link to="/deductions">
                  <i className="bx bx-cut"></i>
                  <span>Payslip Item</span>
                </Link>
              </li>
            )}

            {permissions.includes(PERMISSIONS.INSURANCE_VIEW) && (
              <li>
                <Link to="/insurance">
                  <i className="bx bxs-map-pin"></i>
                  <span>Insurance</span>
                </Link>
              </li>
            )}

            {permissions.includes(PERMISSIONS.LEAVES_VIEW) && (
              <li>
                <Link to="/leaves">
                  <i className="bx bx-lock-open"></i>
                  <span>Leaves</span>
                </Link>
              </li>
            )}

            {permissions.includes(PERMISSIONS.CAR_VIEW) && (
              <li>
                <Link to="/cars">
                  <i className="bx bx-car"></i>
                  <span>Cars</span>
                </Link>
              </li>
            )}

            {permissions.includes(PERMISSIONS.HOUSING_VIEW) && (
              <li>
                <Link to="/housing">
                  <i className="bx bxs-building-house"></i>
                  <span>Housing</span>
                </Link>
              </li>
            )}

            {permissions.includes(PERMISSIONS.RESERVATION_VIEW) && (
              <li>
                <Link to="/reservations">
                  <i className="bx bxs-book"></i>
                  <span>Reservations</span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

export default SidebarContent;
